import { render, staticRenderFns } from "./StaffEmails.vue?vue&type=template&id=068c32a5&"
import script from "./StaffEmails.vue?vue&type=script&lang=js&"
export * from "./StaffEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports